import templateUrl from './pagination.html';


export const paginationComponent = {
	bindings: {
      totalItems: '<',
      currentPage: '<',
      itemPerPage: '<',
      onChange: '&'
	},

	templateUrl,
	
	controller: class PaginationComponent {
		constructor($window) {
			'ngInject';

			this.$window = $window;
		}

		$onInit() {
			const screenWidth = this.$window.innerWidth;
            if (screenWidth < 585) {
				this.maxSize = 1;
			} else {
				this.maxSize = 3;
			}
		}

		_onChange(){
			this.onChange({
				$event: this.currentPage
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/app/common/components/pagination/pagination.component.js